// extracted by mini-css-extract-plugin
module.exports = {"mdc-tab-bar":"mdc-tab-bar"};